import { motion, AnimatePresence } from 'framer-motion'
import { X } from 'lucide-react'
import { useUIStore } from '../hooks/useUIStore'

/**
 * SidePanel — the standard chrome for every panel opened from the header
 * menu (players/game settings, how-to-play, ...), matching the chat panel:
 * a fixed right-side overlay that slides in under the live header height,
 * with a title bar and an always-visible close button. Being fixed keeps it
 * out of the page flow, so opening one never resizes the game canvas.
 */
const SidePanel = ({ isOpen, title, onClose, children }) => {
  const headerHeight = useUIStore((state) => state.headerHeight)

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'tween', duration: 0.25, ease: 'easeOut' }}
          className="fixed right-0 bottom-0 w-80 z-40 flex flex-col bg-gray-800 border-l border-gray-700"
          style={{ top: headerHeight }}
        >
          {/* Header — same chrome as ChatPanel */}
          <div className="p-4 border-b border-gray-700 flex items-center justify-between flex-shrink-0">
            <h3 className="text-lg font-semibold text-white">{title}</h3>
            <button
              onClick={onClose}
              className="p-1 text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex-1 min-h-0 overflow-y-auto">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default SidePanel
